var render = function render(){var _vm=this,_c=_vm._self._c;return _c('u-context-menu',{ref:"context",staticClass:"erp-context-menu"},[_c('list-menu',{on:{"abrir":function($event){return _vm.$emit('abrir')},"edit":function($event){return _vm.$emit('edit')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }